import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function ContatoPage() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    mensagem: ''
  });

  const [orcamentoData, setOrcamentoData] = useState({
    nome: '',
    email: '',
    telefone: '',
    produto: '',
    quantidade: '',
    prazo: '',
    descricao: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [isSubmittingOrcamento, setIsSubmittingOrcamento] = useState(false);
  const [submitSuccessOrcamento, setSubmitSuccessOrcamento] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('https://readdy.ai/api/form/d6kp0kdv117fnkj2gfb0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setSubmitSuccess(true);
        setFormData({ nome: '', email: '', telefone: '', mensagem: '' });
        setTimeout(() => setSubmitSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOrcamentoSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (orcamentoData.descricao.length > 500) {
      alert('A descrição não pode exceder 500 caracteres.');
      return;
    }

    setIsSubmittingOrcamento(true);

    try {
      const response = await fetch('https://readdy.ai/api/form/d6kp0kdv117fnkj2gfb0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(orcamentoData as any).toString(),
      });

      if (response.ok) {
        setSubmitSuccessOrcamento(true);
        setOrcamentoData({
          nome: '',
          email: '',
          telefone: '',
          produto: '',
          quantidade: '',
          prazo: '',
          descricao: ''
        });
        setTimeout(() => setSubmitSuccessOrcamento(false), 5000);
      }
    } catch (error) {
      console.error('Erro ao enviar orçamento:', error);
    } finally {
      setIsSubmittingOrcamento(false);
    }
  };

  const produtos = [
    'Canecas Personalizadas',
    'Copos Personalizados',
    'Camisetas Personalizadas',
    'Bonés Personalizados',
    'Copos Térmicos',
    'Squeezes',
    'Chaveiros',
    'Almofadas',
    'Mousepad',
    'Brindes Corporativos'
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <WhatsAppButton />

      <section className="relative bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-white py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Entre em Contato</h1>
          <p className="text-xl text-gray-200 max-w-2xl mx-auto">
            Estamos prontos para atender você e transformar suas ideias em realidade
          </p>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-3">Solicitar Orçamento</h2>
              <p className="text-gray-600">Preencha o formulário abaixo e receba uma proposta personalizada</p>
            </div>

            <form id="orcamento-form" data-readdy-form onSubmit={handleOrcamentoSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="orcamento-nome" className="block text-sm font-semibold text-gray-700 mb-2">
                    Nome Completo *
                  </label>
                  <input
                    type="text"
                    id="orcamento-nome"
                    name="nome"
                    value={orcamentoData.nome}
                    onChange={(e) => setOrcamentoData({ ...orcamentoData, nome: e.target.value })}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Seu nome completo"
                  />
                </div>

                <div>
                  <label htmlFor="orcamento-email" className="block text-sm font-semibold text-gray-700 mb-2">
                    E-mail *
                  </label>
                  <input
                    type="email"
                    id="orcamento-email"
                    name="email"
                    value={orcamentoData.email}
                    onChange={(e) => setOrcamentoData({ ...orcamentoData, email: e.target.value })}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="seu@email.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="orcamento-telefone" className="block text-sm font-semibold text-gray-700 mb-2">
                    Telefone/WhatsApp *
                  </label>
                  <input
                    type="tel"
                    id="orcamento-telefone"
                    name="telefone"
                    value={orcamentoData.telefone}
                    onChange={(e) => setOrcamentoData({ ...orcamentoData, telefone: e.target.value })}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="(21) 99999-9999"
                  />
                </div>

                <div>
                  <label htmlFor="orcamento-produto" className="block text-sm font-semibold text-gray-700 mb-2">
                    Produto de Interesse *
                  </label>
                  <select
                    id="orcamento-produto"
                    name="produto"
                    value={orcamentoData.produto}
                    onChange={(e) => setOrcamentoData({ ...orcamentoData, produto: e.target.value })}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  >
                    <option value="">Selecione um produto</option>
                    {produtos.map((produto) => (
                      <option key={produto} value={produto}>
                        {produto}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="orcamento-quantidade" className="block text-sm font-semibold text-gray-700 mb-2">
                    Quantidade Estimada *
                  </label>
                  <input
                    type="text"
                    id="orcamento-quantidade"
                    name="quantidade"
                    value={orcamentoData.quantidade}
                    onChange={(e) => setOrcamentoData({ ...orcamentoData, quantidade: e.target.value })}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Ex: 50 unidades"
                  />
                </div>

                <div>
                  <label htmlFor="orcamento-prazo" className="block text-sm font-semibold text-gray-700 mb-2">
                    Prazo Desejado *
                  </label>
                  <input
                    type="text"
                    id="orcamento-prazo"
                    name="prazo"
                    value={orcamentoData.prazo}
                    onChange={(e) => setOrcamentoData({ ...orcamentoData, prazo: e.target.value })}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Ex: 15 dias"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="orcamento-descricao" className="block text-sm font-semibold text-gray-700 mb-2">
                  Descrição do Projeto *
                </label>
                <textarea
                  id="orcamento-descricao"
                  name="descricao"
                  value={orcamentoData.descricao}
                  onChange={(e) => setOrcamentoData({ ...orcamentoData, descricao: e.target.value })}
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                  placeholder="Descreva detalhes do seu projeto, cores, arte, quantidade, etc. (máximo 500 caracteres)"
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">
                  {orcamentoData.descricao.length}/500 caracteres
                </p>
              </div>

              {submitSuccessOrcamento && (
                <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm">
                  ✓ Orçamento enviado com sucesso! Entraremos em contato em breve.
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmittingOrcamento}
                className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmittingOrcamento ? 'Enviando...' : 'Enviar Solicitação de Orçamento'}
              </button>
            </form>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">Outras Formas de Contato</h2>
            <p className="text-gray-600">Escolha a melhor forma de falar conosco</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-green-600 rounded-full mx-auto mb-4">
                <i className="ri-whatsapp-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">WhatsApp</h3>
              <p className="text-gray-600 mb-4 text-sm">Atendimento rápido e direto</p>
              <a
                href="https://wa.me/5521992215234?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20para%20produtos%20personalizados%20da%20JR%20Gráfica%20e%20Sublimação."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors whitespace-nowrap"
              >
                Chamar no WhatsApp
              </a>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-600 rounded-full mx-auto mb-4">
                <i className="ri-phone-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Telefone</h3>
              <p className="text-gray-600 mb-4 text-sm">Ligue para nós</p>
              <a
                href="tel:+5521992215234"
                className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors whitespace-nowrap"
              >
                (21) 99221-5234
              </a>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-full mx-auto mb-4">
                <i className="ri-mail-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">E-mail</h3>
              <p className="text-gray-600 mb-4 text-sm">Envie sua mensagem</p>
              <a
                href="mailto:contato@jrgraficaesublimacao.com.br"
                className="inline-block bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors whitespace-nowrap"
              >
                contato@jrgraficaesublimacao.com.br
              </a>
            </div>
          </div>

          <div className="max-w-2xl mx-auto bg-gray-50 rounded-2xl p-8 md:p-10 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Envie uma Mensagem</h3>

            <form id="contato-form" data-readdy-form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label htmlFor="nome" className="block text-sm font-semibold text-gray-700 mb-2">
                  Nome *
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  value={formData.nome}
                  onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="Seu nome"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                  E-mail *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="seu@email.com"
                />
              </div>

              <div>
                <label htmlFor="telefone" className="block text-sm font-semibold text-gray-700 mb-2">
                  Telefone
                </label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  value={formData.telefone}
                  onChange={(e) => setFormData({ ...formData, telefone: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="(21) 99999-9999"
                />
              </div>

              <div>
                <label htmlFor="mensagem" className="block text-sm font-semibold text-gray-700 mb-2">
                  Mensagem *
                </label>
                <textarea
                  id="mensagem"
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={(e) => setFormData({ ...formData, mensagem: e.target.value })}
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                  placeholder="Escreva sua mensagem aqui... (máximo 500 caracteres)"
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">
                  {formData.mensagem.length}/500 caracteres
                </p>
              </div>

              {submitSuccess && (
                <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm">
                  ✓ Mensagem enviada com sucesso! Retornaremos em breve.
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-semibold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
              </button>
            </form>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">Nossa Localização</h2>
            <p className="text-gray-600">Visite nossa loja física</p>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <iframe
              src="https://www.google.com/maps?q=Rua%20das%20Safiras%2C%2032%2C%20Rocha%20Miranda%2C%20Rio%20de%20Janeiro%20-%20RJ%2C%20CEP%2021511-380&output=embed"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização JR Gráfica e Sublimação"
            ></iframe>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}